import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Observable } from 'rxjs';

import { CoachSettingsGeneralBiographyController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-biography/coach-settings-general-biography.controller';

@Component({
	selector: 'spr-coach-settings-general-biography',
	templateUrl: './coach-settings-general-biography.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoachSettingsGeneralBiographyController],
	host: {
		class: 'h-full',
	},
})
export class CoachSettingsGeneralBiographyComponent {
	public editor = ClassicEditor;
	public editorConfig$: Observable<any>;

	@Input() public biographyForm: FormGroup;

	constructor(_controller: CoachSettingsGeneralBiographyController) {
		this.editorConfig$ = _controller.editorConfig$;
	}
}
